/**
 * Page mot de passe oublié FrontOffice
 */

import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { authApi, getBrandInfo } from '@e-store/shared';
import './auth.css';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const response = await authApi.forgotPassword({ email, portal: 'frontoffice' });

    if (response.error) {
      setError(response.error);
      setIsSubmitting(false);
      return;
    }

    setSuccess(true);
    setIsSubmitting(false);
  };

  return (
    <div className="auth-page frontoffice">
      <div className="auth-container">
        <div className="auth-header">
          <Link to="/login" className="back-link-top">&larr; Retour</Link>
          <h1>{getBrandInfo().name}</h1>
          <h2>Mot de passe oublié</h2>
        </div>

        {success ? (
          <div className="success-block">
            <div className="success-message">
              Email envoyé !
            </div>
            <p className="success-text">
              Si cette adresse email existe, vous recevrez un lien de réinitialisation.
            </p>
            <p className="success-text">
              Veuillez vérifier votre boîte de réception.
            </p>
          </div>
        ) : (
          <>
            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com"
                  required
                />
              </div>

              <button type="submit" className="btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Envoi...' : 'Envoyer le lien'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
